import type { SafetyVideoCategories } from "@unbox/api";
import { ShieldTick } from "@untitledui/icons";
import { Rocket } from "lucide-react";
import type { UnboxTableEmptyState } from "@/components/application/table/unbox-table.types";

export const REVIEW_TABLE_EMPTY_STATES: Record<SafetyVideoCategories, UnboxTableEmptyState> = {
  pendingManualReview: {
    title: "All caught up!",
    description: "No risks need review right now",
    icon: Rocket,
  },
  manuallyReviewed: {
    title: "No videos manually reviewed yet",
    description: "",
    icon: ShieldTick,
  },
  awaitingAction: {
    title: "All caught up!",
    description: "No risks awaiting action",
    icon: Rocket,
  },
  actionInProgress: {
    title: "All caught up!",
    description: "No actions in progress",
    icon: Rocket,
  },
  loggedAsComplete: {
    title: "No Actions Logged as Complete",
    description: "",
    icon: ShieldTick,
  },
  risksDetected: {
    title: "You're safe!",
    description: "No Risks detected in videos.",
    icon: Rocket,
  },
  deemedSafe: {
    title: "No videos marked as safe yet",
    description: "",
    icon: ShieldTick,
  },
  unableToAnalyse: {
    title: "All videos analysed successfully!",
    description: "",
    icon: Rocket,
  },
};
